import Axios from 'axios';
import { Config } from '../apiRoutes';
import { authHeaders, apiErrorMessage } from '../headers';

import {
  BATCHES_INDEX_REQUESTED,
  BATCHES_INDEX_SUCCESS,
  BATCHES_INDEX_FAILURE,
  BATCHES_STATS_REQUESTED,
  BATCHES_STATS_SUCCESS,
  BATCHES_STATS_FAILURE,
  BATCH_FIND_REQUESTED,
  BATCH_FIND_SUCCESS,
  BATCH_FIND_FAILURE,
} from '../types';

const BATCHES_LIMIT = 100;

export const batchesIndex = (status = null, continuationToken = null, append = false) => {
  return async (dispatch) => {
    dispatch({ type: BATCHES_INDEX_REQUESTED, append: append });

    const endPoint = Config.baseUrl + Config.batches;
    const params = { limit: BATCHES_LIMIT };

    if (status) {
      params.status = status;
    }

    if (continuationToken) {
      params.continuation_token = continuationToken;
    }

    return Axios.get(endPoint, { headers: await authHeaders(), params: params })
      .then((response) => {
        dispatch({ type: BATCHES_INDEX_SUCCESS, payload: response.data, append: append });

        if (response.data.continuation_token) {
          return dispatch(batchesIndex(status, response.data.continuation_token, true));
        }

        return response.data;
      })
      .catch((error) => {
        dispatch({ type: BATCHES_INDEX_FAILURE, error: apiErrorMessage(error, 'Could not load batches.') });
      });
  }
};

export const batchesStats = () => {
  return async (dispatch) => {
    dispatch({ type: BATCHES_STATS_REQUESTED });

    const endPoint = Config.baseUrl + Config.batchesStats;

    return Axios.get(endPoint, { headers: await authHeaders() })
      .then((response) => {
        dispatch({ type: BATCHES_STATS_SUCCESS, payload: response.data });
        return response.data;
      })
      .catch((error) => {
        dispatch({ type: BATCHES_STATS_FAILURE, error: apiErrorMessage(error, 'Could not load batch stats.') });
      });
  }
};

const pdfOptionParams = (options) => {
  const params = {};
  Object.keys(options || {}).forEach((key) => {
    params[key] = options[key];
  });
  return params;
};

export const batchPdf = (batchId, options = {}) => {
  return async () => {
    const endPoint = Config.baseUrl + Config.batch + batchId + '/pdf';

    return Axios.get(endPoint, { headers: await authHeaders(), params: pdfOptionParams(options) })
      .then((response) => response.data)
      .catch((error) => Promise.reject(new Error(apiErrorMessage(error, 'Could not generate the batch PDF.'))));
  }
};

export const batchesPdf = (status, options = {}) => {
  return async () => {
    const endPoint = Config.baseUrl + Config.batchesPdf;

    return Axios.get(endPoint, { headers: await authHeaders(), params: { status: status, ...pdfOptionParams(options) } })
      .then((response) => response.data)
      .catch((error) => Promise.reject(new Error(apiErrorMessage(error, 'Could not generate the batches PDF.'))));
  }
};

export const batchReturnToStock = (batchId) => {
  return async () => {
    const endPoint = Config.baseUrl + Config.batch + batchId + '/return_to_stock';

    return Axios.post(endPoint, {}, { headers: await authHeaders() })
      .then((response) => response.data)
      .catch((error) => Promise.reject(new Error(apiErrorMessage(error, 'Could not mark the batch for return to stock.'))));
  }
};

export const batchSetAside = (batchId) => {
  return async () => {
    const endPoint = Config.baseUrl + Config.batch + batchId + '/set_aside';

    return Axios.post(endPoint, {}, { headers: await authHeaders() })
      .then((response) => response.data)
      .catch((error) => Promise.reject(new Error(apiErrorMessage(error, 'Could not set the batch aside.'))));
  }
};

export const batchFind = (batchId) => {
  return async (dispatch) => {
    dispatch({ type: BATCH_FIND_REQUESTED });

    const endPoint = Config.baseUrl + Config.batch + batchId;

    return Axios.get(endPoint, { headers: await authHeaders() })
      .then((response) => {
        dispatch({ type: BATCH_FIND_SUCCESS, payload: response.data });
        return response.data;
      })
      .catch((error) => {
        dispatch({ type: BATCH_FIND_FAILURE, error: apiErrorMessage(error, 'Could not load the batch.') });
        return null;
      });
  }
};
